import { render, staticRenderFns } from "./AlertValidate.vue?vue&type=template&id=b74d7cee"
import script from "./AlertValidate.vue?vue&type=script&lang=js"
export * from "./AlertValidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports